<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { commissiontypeService } from "../../../../services/saleservice/commissiontype.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Commission Type List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      commissionTypeList: {},
      amountTypeList: {},
      fetchingStats: false,
      title: "Commission Type List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      commissiontypeService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.commissionTypeList = response;
        });
    },

    deleted: function(id) {
      commissiontypeService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-commission-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-commission-add'}" :title="$t('setting.configuration.commission-rule.text')" />
    <List v-bind:dataList="commissionTypeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'seller_amount', type: 'currency'}, {name: 'agency_amount', type: 'currency'}, {name: 'seller_type_name'}, {name: 'agency_type_name'}, {name: 'commission_for_name'}]"
          v-bind:fields="[ `commission_for_name: ${$t('setting.configuration.commission-rule.for')}`, `name: ${$t('setting.configuration.commission-rule.name')}`, 
            `seller_amount: ${$t('setting.configuration.commission-rule.for-seller')}`, `seller_type_name: ${$t('setting.configuration.commission-rule.seller-type')}`, 
            `agency_amount: ${$t('setting.configuration.commission-rule.for-agency')}`, `agency_type_name: ${$t('setting.configuration.commission-rule.agency-type')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-commission-edit'}"
          v-bind:filter="{
            search: ['loan_templates.name', 'loan_templates.name_en'],
            dropdown: [],

          }"
          
    />      
  </Layout>
</template>